// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class SiteAccountGetSiteAccountDefaultResponse {
    static getAttributeTypeMap() {
        return SiteAccountGetSiteAccountDefaultResponse.attributeTypeMap;
    }
}
SiteAccountGetSiteAccountDefaultResponse.discriminator = undefined;
SiteAccountGetSiteAccountDefaultResponse.attributeTypeMap = [
    {
        "name": "success",
        "baseName": "success",
        "type": "boolean"
    },
    {
        "name": "messages",
        "baseName": "messages",
        "type": "Array<string>"
    },
    {
        "name": "data",
        "baseName": "data",
        "type": "AccountModel"
    }
];
//# sourceMappingURL=siteAccountGetSiteAccountDefaultResponse.js.map